import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const GlassType = ({ value, onChange, id = 'GlassType', label = 'Glass Type', disabled = false }) => {
    const defaultColorValue = value?.value || '#F8F8FF'; // safely fallback
    const defaultColorLabel = value?.label || 'Clear';
    const [selectedGlassType, setSelectedGlassType] = useState(defaultColorValue);

    useEffect(() => {
        setSelectedGlassType(value?.value || '#F8F8FF');
    }, [value]);

    const handleGlassTypeChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text;

        setSelectedGlassType(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    // 🔥 Trigger initial onChange once when mounted
    useEffect(() => {
        onChange({ value: defaultColorValue, label: defaultColorLabel });
    }, []); // empty deps = only once on mount

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <select
                disabled={disabled}
                id={id}
                value={selectedGlassType}
                onChange={handleGlassTypeChange}
            >
                <option value="#F8F8FF">
                    {selectedGlassType === '#F8F8FF' ? 'Clear ✔' : 'Clear'}
                </option>
                <option value="#DCDCDC">
                    {selectedGlassType === '#DCDCDC' ? 'Textured ✔' : 'Textured'}
                </option>
                <option value="#E0E0E0">
                    {selectedGlassType === '#E0E0E0' ? 'Tinted ✔' : 'Tinted'}
                </option>
            </select>
        </div>
    );
};

export default GlassType;
